import React from 'react';
import styled from 'styled-components';
import media from '../style/media';
import { T, useT, useSetLang, useLang } from "../Translation/index";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 58px;
  width: 108px;
  float:right;
  ${media.tablet`
    height: 44px;
    width: 108px;
  `}
`;

const ButtonLeft = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color:rgb(253, 253, 253);
  //border-radius: 10%;
  border-top-left-radius: 25%;
  border-bottom-left-radius: 25%;
  color: #008CBA;
  ##cursor: pointer;
  height: 25px;
  width: 40px;
  border: 2px solid #008CBA;
`;
const ButtonRight = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color:rgb(253, 253, 253);
  //border-radius: 10%;
  border-top-right-radius: 25%;
  border-bottom-right-radius: 25%;
  color: #008CBA;
  ##cursor: pointer;
  height: 25px;
  width: 40px;
  border: 2px solid #008CBA;
`;
const ButtonClickedLeft = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #008CBA;
  //border-radius: 10%;
  border-top-left-radius: 25%;
  border-bottom-left-radius: 25%;
  color:rgb(253, 253, 253);
  ##cursor: pointer;
  height: 25px;
  width: 40px;
  border: 2px solid #008CBA;
`;
const ButtonClickedRight = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #008CBA;
  //border-radius: 10%;
  border-top-right-radius: 25%;
  border-bottom-right-radius: 25%;
  color:rgb(253, 253, 253);
  ##cursor: pointer;
  height: 25px;
  width: 40px;
  border: 2px solid #008CBA;
`;
const ButtonGroup = () => {
    const setLang = useSetLang();
    const lang = useLang();
    return (

        

        <Container>
            {lang==='tw' ? (
            <Container>
            <ButtonClickedLeft  onClick={() => setLang("tw")}>繁</ButtonClickedLeft>
            <ButtonRight onClick={() => setLang("en")}>Eng</ButtonRight>
            </Container>  
        ) : (
            <Container>
            <ButtonLeft  onClick={() => setLang("tw")}>繁</ButtonLeft>
            <ButtonClickedRight onClick={() => setLang("en")}>Eng</ButtonClickedRight>
            </Container>
        )}
        </Container>
      );
};
export default ButtonGroup;